import { render } from "./index.vue?vue&type=template&id=b1897f6a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b1897f6a&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1897f6a"],['__file',"src/vab/layouts/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b1897f6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b1897f6a', __exports__)) {
    console.log('reload')
    api.reload('b1897f6a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=b1897f6a&scoped=true", () => {
    console.log('re-render')
    api.rerender('b1897f6a', render)
  })

}


export default __exports__